import { render, staticRenderFns } from "./BranchDialog.vue?vue&type=template&id=1c46a91c"
import script from "./BranchDialog.vue?vue&type=script&lang=js"
export * from "./BranchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports